module.exports = __webpack_public_path__ + "img/Bougie_led.b143074.png";